<div class="container-fluid ptCustom">

  <div class="row">
    <div class="col-12 my-2">
      <div class="card shadow-sm rounded-lg">
        <div class="card-body p-4">
          <div class="row align-items-end">
              <div class="input-group mb-3 mb-xl-0">
                  <input (keyup)="enterSearchTerm($event)" [(ngModel)]='searchText' type="text" class="form-control form-control-lg" placeholder="search pending applications...">
                  <button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter"
                          data-bs-toggle="dropdown" aria-expanded="false">
                      Status: {{statusSearch.display}}
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="searchFilter">
                      <li>
                          <a *ngIf="statusSearch.value != -1" (click)="changeStatusSearch(-1)"
                             class="dropdown-item" href="javascript:void(0)">Status: All</a>
                      </li>
                      <li>
                          <a *ngIf="statusSearch.value != 1" (click)="changeStatusSearch(1)"
                             class="dropdown-item" href="javascript:void(0)">Status: Pending</a>
                      </li>
                      <li>
                          <a *ngIf="statusSearch.value != 2" (click)="changeStatusSearch(2)"
                             class="dropdown-item" href="javascript:void(0)">Status: Approved</a>
                      </li>
                      <li>
                          <a *ngIf="statusSearch.value != 3" (click)="changeStatusSearch(3)"
                             class="dropdown-item" href="javascript:void(0)">Status: Denied</a>
                      </li>
                  </ul>
                  <button (click)="hitSearchBtn()" type="button" class="btn btn-lg btn-sb border-lb"><i class="fas fa-search"></i></button>
                  <button (click)="clearSearch()" type="button" class="btn btn-lg btn-primary border-lb"><i class="fas fa-times"></i></button>
              </div>
            <div class="search-filters py-2">
              <!-- hide if none -->
              <ul class="filter-tags" *ngIf="keywordSearches.length > 0">
                <li (click)="removeSearchTerm(search)" *ngFor="let search of keywordSearches" class="tag">
                  <span>{{search}}</span><span class="remove-tag"><i class="fa fa-times-circle"></i></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
            <div class="fs-5 fst-italic">viewing {{itemStart}}-{{itemEnd}} of {{filteredApps}} pending applications</div>
          </div>
          <div class="card no-shadow border border-db bg-db p-2">
            <div class="">
                <table class="table table-hover align-middle m-0">
                    <thead>
                        <tr>
                            <th>
                                <a (click)="changeSortType(1)" href="javascript:void(0)" class="sort-icons">
                                    <span [ngClass]="{'active': sortType == 1}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                    <span [ngClass]="{'active': sortType == 2}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                </a>Company
                            </th>
                            <th>
                                <a (click)="changeSortType(2)" href="javascript:void(0)" class="sort-icons">
                                    <span [ngClass]="{'active': sortType == 3}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                    <span [ngClass]="{'active': sortType == 4}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                </a>Liaison
                            </th>
                            <th>
                                <a (click)="changeSortType(3)" href="javascript:void(0)" class="sort-icons">
                                    <span [ngClass]="{'active': sortType == 5}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                    <span [ngClass]="{'active': sortType == 6}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                </a>Status
                            </th>
                            <th>
                                <a (click)="changeSortType(4)" href="javascript:void(0)" class="sort-icons">
                                    <span [ngClass]="{'active': sortType == 7}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                    <span [ngClass]="{'active': sortType == 8}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                </a>Level
                            </th>
                            <th>
                                <a (click)="changeSortType(5)" href="javascript:void(0)" class="sort-icons">
                                    <span [ngClass]="{'active': sortType == 9}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                    <span [ngClass]="{'active': sortType == 10}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                </a>Salesperson
                            </th>
                            <th class="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let app of applications">
                            <td>{{app.companyName}}</td>
                            <td>
                                <div>
                                    <p class="m-0">{{app.liaisonName}}</p>
                                    <small class="text-muted">
                                        <a href="javascript:void(0);">{{app.liaisonEmail}}</a>
                                    </small>
                                </div>
                            </td>
                            <td>{{app.status}}</td>
                            <td>{{app.membershipLevel}}</td>
                            <td>{{app.salesperson}}</td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-lg btn-outline-dark action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="far fa-ellipsis-v"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item" [routerLink]="['/admin-portal/chamber/pending-applications/details/', app.appId]" routerLinkActive="activePage"><i class="fa-light fa-eye fa-fw"></i> View Application</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
          </div>
          <div class="row mt-4">
            <nav aria-label="table navigation" class="d-flex align-items-center justify-content-center">
              <ngb-pagination class="pagination mb-0" [maxSize]="5" [ellipses]="true"
                              [collectionSize]="filteredApps"
                              [(page)]="currentPageNum" [pageSize]="itemsPerPage">
              </ngb-pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>